module.exports = __webpack_public_path__ + "static/media/loader.7b7babc5.gif";